













import { Vue, Component, Prop, Provide, Emit, Watch, Model,Inject } from 'vue-property-decorator';
import { CreateElement } from 'vue';
import { Subject, Subscription } from 'rxjs';
import { ControlInterface } from '@/api/interface/control';
import { UIActionTool,Util,ViewTool } from '@/utils';
import NavDataService from '@/api/service/app/navdata-service';
import AppCenterService from "@service/app/app-center-service";
import AppIndexViewService from './app-index-view-appmenu-service';
import { Environment } from '@/environments/environment';
import AuthService from '@/api/authservice/auth-service';


@Component({
    components: {

    }
})
export default class AppIndexViewBase extends Vue implements ControlInterface {

    /**
     * 名称
     *
     * @type {string}
     * @memberof AppIndexViewBase
     */
    @Prop() public name?: string;
    @Prop() public activePath?: string;

    /**
     * 菜单列表
     */
    @Prop() public menuItems!: Array<any>;

    /**
     * 视图通讯对象
     *
     * @type {Subject<ViewState>}
     * @memberof AppIndexViewBase
     */
    @Prop() public viewState!: Subject<ViewState>;

    /**
     * 应用上下文
     *
     * @type {*}
     * @memberof AppIndexViewBase
     */
    @Prop() public context!: any;

    /**
     * 视图参数
     *
     * @type {*}
     * @memberof AppIndexViewBase
     */
    @Prop() public viewparams!: any;

    /**
     * 视图状态事件
     *
     * @public
     * @type {(Subscription | undefined)}
     * @memberof AppIndexViewBase
     */
    public viewStateEvent: Subscription | undefined;

    /**
     * 获取部件类型
     *
     * @returns {string}
     * @memberof AppIndexViewBase
     */
    public getControlType(): string {
        return 'APPMENU'
    }



    /**
     * 建构部件服务对象
     *
     * @type {AppIndexViewService}
     * @memberof AppIndexViewBase
     */
    // public service: AppIndexViewService = new AppIndexViewService({ $store: this.$store });



    /**
     * 关闭视图
     *
     * @param {any} args
     * @memberof AppIndexViewBase
     */
    public closeView(args: any): void {
        let _this: any = this;
        _this.$emit('closeview', [args]);
    }

    /**
     *  计数器刷新
     *
     * @memberof AppIndexViewBase
     */
    public counterRefresh(){
        const _this:any =this;
        if(_this.counterServiceArray && _this.counterServiceArray.length >0){
            _this.counterServiceArray.forEach((item:any) =>{
                if(item.refreshData && item.refreshData instanceof Function){
                    item.refreshData();
                }
            })
        }
    }



    /**
     * 获取多项数据
     *
     * @returns {any[]}
     * @memberof AppIndexViewBase
     */
    public getDatas(): any[] {
        return [];
    }

    /**
     * 获取单项树
     *
     * @returns {*}
     * @memberof AppIndexViewBase
     */
    public getData(): any {
        return null;
    }

    /**
     * 导航模式(route:面包屑模式、tab:分页导航模式)
     *
     * @type {string}
     * @memberof AppIndexViewBase
     */
    @Prop({default:'tab'}) public navModel?:string;

    /**
     * 视图标识
     *
     * @type {string}
     * @memberof AppIndexViewBase
     */
    @Prop() public viewtag!:string;

    /**
     * 显示处理提示
     *
     * @type {boolean}
     * @memberof AppIndexViewBase
     */
    @Prop({ default: true }) public showBusyIndicator?: boolean;

    /**
     * 菜单数据
     *
     * @public
     * @type {any[]}
     * @memberof AppIndexViewBase
     */
    @Provide()
    public menus: any[] = [];

    /**
     * 菜单收缩改变
     *
     * @type {boolean}
     * @memberof AppIndexViewBase
     */
    @Model() public collapsechange?: boolean;

    /**
     * 监听菜单收缩
     *
     * @param {*} newVal
     * @param {*} oldVal
     * @memberof AppIndexViewBase
     */
    @Watch('collapsechange')
    onCollapsechangeChange(newVal: any, oldVal: any) {
        if (newVal !== this.isCollapse) {
            this.isCollapse = !this.isCollapse;
        }
    }

    /**
     * 当前模式，菜单在顶部还是在底部
     *
     * @type {*}
     * @memberof AppIndexViewBase
     */
    @Prop() mode: any;

    /**
     * 应用起始页面
     *
     * @type {boolean}
     * @memberof AppIndexViewBase
     */
    @Prop({ default: false }) isDefaultPage?: boolean;

    /**
     * 空白视图模式
     *
     * @type {boolean}
     * @memberof AppIndexViewBase
     */
    @Prop({ default: false }) isBlankMode?:boolean;

    /**
     * 默认打开视图
     *
     * @type {*}
     * @memberof AppIndexViewBase
     */
    @Prop() defPSAppView: any;

    /**
     * 默认激活的index
     *
     * @type {*}
     * @memberof AppIndexViewBase
     */
    @Provide() defaultActive: any = null;

    /**
     * 当前选中主题
     *
     * @type {*}
     * @memberof AppIndexViewBase
     */
    @Prop() selectTheme: any;

    /**
     * 默认打开的index数组
     *
     * @type {any[]}
     * @memberof AppIndexViewBase
     */
    @Provide() public defaultOpeneds: any[] = [];

    /**
     * 是否展开
     *
     * @type {boolean}
     * @memberof AppIndexViewBase
     */
    @Provide() public isCollapse: boolean = false;

    /**
     * 触发方式，默认click
     *
     * @type {string}
     * @memberof AppIndexViewBase
     */
    @Provide() trigger: string = 'click';

    /**
     * 计数器数据
     *
     * @type {*}
     * @memberof AppIndexViewBase
     */
    public counterdata: any = {};

    /**
     * 建构权限服务对象
     *
     * @type {AuthService}
     * @memberof AppIndexViewBase
     */
    public authService:AuthService = new AuthService({ $store: this.$store });

    /**
     * vue  生命周期
     *
     * @memberof AppIndexViewBase
     */
    public created() {
        this.afterCreated();
        const tempThis = this as any;
        tempThis.$bus.$on('openMenuFromHome',(e:any)=>{
            this.select(e,[]);
        })
    }

    /**
     * 执行created后的逻辑
     *
     *  @memberof AppIndexViewBase
     */
    public afterCreated(){
        if (Object.is(this.mode, 'horizontal')) {
            this.trigger = 'hover';
        }
    }

    /**
     * vue 生命周期
     *
     * @memberof AppIndexViewBase
     */
    public destroyed() {
        this.afterDestroy();
    }

    /**
     * 执行destroyed后的逻辑
     *
     * @memberof AppIndexViewBase
     */
    public afterDestroy() {
        if (this.viewStateEvent) {
            this.viewStateEvent.unsubscribe();
        }
    }

    /**
     * 获取菜单项数据
     *
     * @public
     * @param {any[]} items
     * @param {string} name
     * @returns
     * @memberof AppIndexViewBase
     */
    public compute(items: any[], name: string) {
        const item: any = {};
        items.some((_item: any) => {
            if (name && Object.is(_item.label, name)) {
                Object.assign(item, _item);
                return true;
            }
            if (_item.items && Array.isArray(_item.items)) {
                const subItem = this.compute(_item.items, name);
                if (Object.keys(subItem).length > 0) {
                    Object.assign(item, subItem);
                    return true;
                }
            }
            return false;
        });
        return item;
    }

 @Watch("activePath")
  public onRouteChange(newVal: any) {
    const item = this.computeByPath(this.menuItems, this.activePath||'')
    this.defaultActive = item.label
  }

public computeByPath(items: any[], path: string) {
    const item: any = {};
    items.some((_item: any) => {
        if (path && Object.is(_item.path, path)) {
            Object.assign(item, _item);
            return true;
        }
        if (_item.items && Array.isArray(_item.items)) {
            const subItem = this.computeByPath(_item.items, path);
            if (Object.keys(subItem).length > 0) {
                Object.assign(item, subItem);
                return true;
            }
        }
        return false;
    });
    return item;
}

    /**
     * 菜单项选中处理
     *
     * @param {*} index
     * @param {any[]} indexs
     * @returns
     * @memberof AppIndexViewBase
     */
    public select(index: any, indexs: any[]) {
        let item = this.compute(this.menuItems, index);
        if (Object.keys(item).length === 0) {
            return;
        }
        this.click(item);
    }

    /**
     * 菜单点击
     *
     * @public
     * @param {*} item 菜单数据
     * @memberof AppIndexViewBase
     */
    public click(item: any) {
        if (item) {
            let navDataService = NavDataService.getInstance();
            if(Object.is(this.navModel,"route")){
                navDataService.removeNavData(this.viewtag);
            }
            const prefix: any = '/appindexview/null'
            const path: any = item.path
            if(Object.is(this.$route.fullPath,path)){
                return;
            }
            this.$nextTick(function(){
                this.menuJumpTo(path, item)
            })
        }
    }

    /**
     * 菜单导航跳转
     */
    public menuJumpTo(path: any, item: any) {
        this.$router.push(path);
    }

    /**
     * 提示框主题样式
     *
     * @readonly
     * @type {string}
     * @memberof AppIndexViewBase
     */
    get popperClass(): string {
        return 'app-popper-menu ' + this.selectTheme;
    }

}
